import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, of } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComplaintSuggestionService } from 'src/app/modules/complaints-suggestions/_services/complaints-suggestions.service';
import { catchError } from 'rxjs/operators';
import { HotToastService } from '@ngneat/hot-toast';
import { CaptchaService } from '../_services/CaptchaService.service';

@Component({
  selector: 'app-add-complaint-suggestion',
  templateUrl: './add-complaint-suggestion.component.html',
  styleUrls: ['./add-complaint-suggestion.component.scss']
})
export class AddComplaintSuggestionComponent implements OnInit, OnDestroy {
  language: any;
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = [];
  formGroup: FormGroup;
  MobilePattern = "(5)[0-9]{8}";
  NoWhitespacePattern = "^([\u0621-\u064A]+ )+[\u0621-\u064A]+$|^[\u0621-\u064A]+$|^([a-zA-Z]+ )+[a-zA-Z]+$|^[a-zA-Z]+$";
  IDPattern = /^(?=\D*\d)(?=\w{10}$)[\da-zA-Z]*$/;
  Types$;
  Writers$;
  captchaCode: string;
  userInput: string = '';
  isValid: boolean | undefined;
  constructor(private ComplaintSuggestionService: ComplaintSuggestionService,private fb: FormBuilder,
     private translationService: TranslationService,private toast: HotToastService,private captchaService: CaptchaService) { }
    get ApiComSugTypes() {
    return this.formGroup.controls['ApiComSugTypes'] as FormArray;
  }
  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    this.LoadAllTypes();
    this.LoadAllWriters();
    this.loadForm();
    this.captchaCode = this.captchaService.getCaptchaCode();
    this.isLoading$ = this.ComplaintSuggestionService.isLoading$;
  }
  refreshCaptcha() {
    this.captchaService.generateCaptcha();
    this.captchaCode = this.captchaService.getCaptchaCode();
    this.isValid = undefined;
  }

  validateCaptcha() {
    this.isValid = this.captchaService.validateCaptcha(this.userInput);
  }
  onCheckboxChange(e) {
    const checkboxes: FormArray = this.formGroup.get('ApiComSugTypes') as FormArray;
    if (e.target.checked) {
      checkboxes.push(this.fb.control(e.target.value));
    } else {
      const index = checkboxes.controls.findIndex(x => x.value === e.target.value);
      checkboxes.removeAt(index);
    }
  }
  LoadAllTypes() {
    this.Types$ = this.ComplaintSuggestionService.GetAllComplaintOrSuggestionTypes();
  }
  LoadAllWriters() {
    this.Writers$ = this.ComplaintSuggestionService.GetAllComplaintOrSuggestionWriter();
  }

  loadForm() {

    this.formGroup = this.fb.group({
      Id: [0],
      PatientName: ['', [Validators.required,Validators.pattern(this.NoWhitespacePattern)]],
      Mobile: ['', [Validators.required,Validators.pattern(this.MobilePattern)]],
      PassportNo: ['', [Validators.required,Validators.pattern(this.IDPattern)]],
      FileNo: [''],
      Type: ['1', Validators.required],
      ApiComplaintSuggestionWriterId: '',
      ComplaintSuggestion:['',[Validators.required,Validators.minLength(10),Validators.maxLength(3000),Validators.pattern('^[a-zA-Z0-9\u0621-\u064A ]+$')]],
      ApiComSugTypes: this.fb.array([])
    });
  }
  submit()
  {
    this.formGroup.markAllAsTouched();
    if (!this.formGroup.valid) {
      return;
    }
    const formValues = this.formGroup.value;

    if (formValues.ApiComSugTypes.length <= 0)
    {
      if (this.language == "ar") {
        this.toast.warning("<b> يجب اختيار الشكوى/الاقتراح ضد شخص واحد علي الاقل من القائمة</b>", { style: { padding: '20px' } });
      }
      else {
        this.toast.warning("<b>You must choose Complaint / Suggestion against who at least one from the list</b>", { style: { padding: '20px' } });
      }
      return
    }
    if (formValues.Type == 1 && !formValues.ApiComplaintSuggestionWriterId)
      {
        if (this.language == "ar") {
          this.toast.warning("<b> يجب اختيار كاتب النموذج</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>You Must Choose The Writer</b>", { style: { padding: '20px' } });
        }
        return
      }
    this.ComplaintSuggestionService.showLoader();
    const Subscr = this.ComplaintSuggestionService.AddComplaintOrSuggestion(formValues).pipe(
      catchError((errorMessage) => {
        this.ComplaintSuggestionService.hideLoader();
        return of(errorMessage);
      })
    ).subscribe(res => {
  
      if (res.isSuccess && res.responseCode == 200) {
        
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.ComplaintSuggestionService.hideLoader();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      //   this.formGroup.setControl('ApiComSugTypes', this.fb.array([]));
      //  this.clearFormArray()
      //  this.formGroup.reset();
       
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.ComplaintSuggestionService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.ComplaintSuggestionService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.ComplaintSuggestionService.hideLoader();

      }
    });
    this.subscriptions.push(Subscr);

  }
  clearFormArray() {
    while (this.ApiComSugTypes.length !== 0) {
      this.ApiComSugTypes.removeAt(0);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }
  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  controlHasError(validation: string, controlName: string) {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }
  isControlTouched(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
